import { http } from '../api/http';
import type { Banner } from '../types/Banner';

export interface CreateBannerDto {
  positionId?: string | number | bigint | null;
  title: string;
  imageEsUrl?: string | null;
  imageEnUrl?: string | null;
  linkUrl?: string | null;
  publishFrom?: string | null;
  publishTo?: string | null;
  sortOrder?: number;
  isActive?: boolean;
}

export interface UpdateBannerDto {
  positionId?: string | number | bigint | null;
  title?: string;
  imageEsUrl?: string | null;
  imageEnUrl?: string | null;
  linkUrl?: string | null;
  publishFrom?: string | null;
  publishTo?: string | null;
  sortOrder?: number;
  isActive?: boolean;
}

export interface BannerPosition {
  id: number | string;
  name: string;
  slug: string;
}

export const BannersService = {
  // Métodos públicos
  getPublicHomeBanners() {
    return http<Banner[]>('/public/banners?position=home', { auth: false });
  },

  getAdminSidebarBanners() {
    return http<Banner[]>('/public/banners?position=admin_sidebar', { auth: false });
  },

  // Métodos para administradores - Posiciones
  getPositions() {
    return http<BannerPosition[]>('/banners/positions');
  },

  createPosition(data: { name: string; slug: string }) {
    return http<BannerPosition>('/banners/positions', {
      method: 'POST',
      body: data,
    });
  },

  updatePosition(id: string | number, data: { name?: string; slug?: string }) {
    return http<BannerPosition>(`/banners/positions/${id}`, {
      method: 'PATCH',
      body: data,
    });
  },

  deletePosition(id: string | number) {
    return http<void>(`/banners/positions/${id}`, {
      method: 'DELETE',
    });
  },

  // Métodos para administradores - Banners
  getBanners(params?: {
    position?: string;
    includeInactive?: boolean;
    onlyPublishedNow?: boolean;
  }) {
    const query = new URLSearchParams();
    if (params?.position) query.append('position', params.position);
    if (params?.includeInactive) query.append('includeInactive', '1');
    if (params?.onlyPublishedNow) query.append('onlyPublishedNow', '1');
    
    return http<Banner[]>(`/banners${query.toString() ? `?${query}` : ''}`);
  },

  createBanner(data: CreateBannerDto) {
    return http<Banner>('/banners', {
      method: 'POST',
      body: data,
    });
  },

  updateBanner(id: string | number, data: UpdateBannerDto) {
    return http<Banner>(`/banners/${id}`, {
      method: 'PATCH',
      body: data,
    });
  },

  deleteBanner(id: string | number) {
    return http<void>(`/banners/${id}`, {
      method: 'DELETE',
    });
  },

  toggleBanner(id: string | number, isActive: boolean) {
    return http<Banner>(`/banners/${id}/toggle`, {
      method: 'PATCH',
      body: { isActive },
    });
  },

  reorderBanners(positionId: string | number | null, orderedIds: (string | number)[]) {
    return http<void>('/banners/reorder', {
      method: 'POST',
      body: { positionId, orderedIds },
    });
  },

  moveBanner(id: string | number, direction: 'up' | 'down') {
    return http<void>(`/banners/${id}/move`, {
      method: 'POST',
      body: { direction },
    });
  },
};
